import { Directive, inject, Renderer2 } from '@angular/core';

@Directive({
  selector: '[idpInspirationSubNavContainerBase]',
  standalone: true
})
export class InspirationSubNavContainerBaseDirective {
  inspirationSubNavClicked = false;
  isInspireMenu!: boolean;
  isLegacyApp!: boolean;
  headerHeight = 0;

  rend = inject(Renderer2);

  calculateTotalHeight(): number {
    const alertHeight = this.getElementHeight('.alert-advisory-main-container');
    const navHeight = this.getElementHeight('.header-container');
    const widgetHeight = this.inspirationSubNavClicked
      ? 0
      : this.getElementHeight('.widgets-container');
    return alertHeight + navHeight + widgetHeight;
  }

  getElementHeight(selector: string): number {
    const element = document.body.querySelector(selector);
    return element?.clientHeight || 0;
  }

  updateSubNavMargin(): void {
    const subNav = document.querySelector(
      '.inspiration-sub-nav-container'
    ) as HTMLElement;
    if (subNav) {
      this.rend.setStyle(subNav, 'margin-top', `${this.headerHeight}px`);
    }
  }
}
